import { render, staticRenderFns } from "./Entertainment.vue?vue&type=template&id=676950ec"
import script from "./Entertainment.vue?vue&type=script&lang=js"
export * from "./Entertainment.vue?vue&type=script&lang=js"
import style0 from "./Entertainment.vue?vue&type=style&index=0&id=676950ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports